import * as queryString from "query-string";
import { useQuery } from "@tanstack/react-query";
import Loading from "../../components/Loading/Loading";
import DetailsUser from "./DetailsUser";
import HistoryInstall from "./HistoryInstall";
import HistoryCharge from "./HistoryCharge";
import HistoryTransaction from "./HistoryTransaction";
import { useContext } from "react";
import { WindowSizeContext } from "../../Context/WindowSizeContext";
import { TabPanel, TabView } from "primereact/tabview";
import { UsersId } from "../../services/services";
import HistoryReceivingNonCashGifts from "./HistoryReceivingNonCashGifts";
import HistoryConvertingCoinsIntoCash from "./HistoryConvertingCoinsIntoCash";

const User = ({ location }) => {
  const query = queryString.parse(location.search);
  const { isMobile } = useContext(WindowSizeContext);

  const {
    data: detailsUsers,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["UsersId", query?.userId],
    queryFn: () => UsersId(query.userId),
    select: (res) => res,
    staleTime: 60 * 60 * 1000,
    retry: false,
    enabled: !!query?.userId,
  });

  if (!detailsUsers) return <Loading />;

  const sections = [
    {
      component: <HistoryInstall isMobile={isMobile} id={query?.userId} />,
      title: " لیست نصب های کاربر ",
      desktopCol: "col-xl-12",
    },
    {
      component: <HistoryTransaction isMobile={isMobile} id={query?.userId} />,
      title: "  تاریخچه دریافت سکه ",
      desktopCol: "col-xl-12",
    },
    {
      component: (
        <HistoryReceivingNonCashGifts
          isMobile={isMobile}
          Name={detailsUsers?.fullName}
        />
      ),
      title: "  تاریخچه دریافت هدیه غیر نقدی",
      desktopCol: "col-xl-12",
    },
    {
      component: (
        <HistoryConvertingCoinsIntoCash
          isMobile={isMobile}
          Name={detailsUsers?.fullName}
        />
      ),
      title: "تاریخچه تبدیل سکه به پول نقد",
      desktopCol: "col-xl-12",
    },
    {
      component: <HistoryCharge isMobile={isMobile} id={query?.userId} />,
      title: "تاریخچه شارژها",
      desktopCol: "col-xl-12",
    },
  ];

  return (
    <div className="custom-container mt-3">
      <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
        <h4>{detailsUsers?.fullName}</h4>
        <h5>{detailsUsers?.phoneNumber}</h5>
      </div>
      <DetailsUser detailsUsers={detailsUsers} />

      {isMobile ? (
        <TabView className="custom-tabview farsi-monospace-digit compact-paginator ">
          {sections.map((s, i) => (
            <TabPanel header={s.title} key={i}>
              {s.component}
            </TabPanel>
          ))}
        </TabView>
      ) : (
        <div className="row g-3 mt-4">
          {sections.map((s, i) => (
            <div key={i} className={`${s.desktopCol} col-12 d-flex`}>
              <div className="w-100">{s.component}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default User;
